import {
	TOGGLE_STREETSCAPE_TRACKER_DIALOG,
	SET_FORM_STATE,
	GET_STREETSCAPE_TRACKER,
	GET_COMMENTS_HISTORY,
	GET_STREETSCAPE_TRACKER_TO_EDIT,
	GET_STREETSCAPE_TRACKER_TABLE,
	GET_LOCAL_DROPDOWN,
	GET_CLUSTER_DROPDOWN,
	GET_SITENAME_DROPDOWN,
	GET_ACTIVATION_STATUS_DROPDOWN,
	GET_D7_STATUS_DROPDOWN
} from '../actions/StreetScapeTrackerActions';

const initialState = {
	streetScapeTrackerTable: [],
	selectedStreetScapeId: 0,
	commentsHistory: {},
	streetScapeDialogVisibility: false,
	siteLocalDropdown: [],
	siteClusterDropdown: [],
	siteNameDropdown: [],
	activationStatusDropdown: [],
	d7StatusDropdown: [],
	formState: {
		values: {},
		isValid: false,
		touched: {},
		errors: {},
		submit: false
	}
};

const streetScapeTrackerReducer = (state = initialState, action) => {
	switch (action.type) {
					case TOGGLE_STREETSCAPE_TRACKER_DIALOG: {
						return {
							...state,
							streetScapeDialogVisibility: action.visible,
							selectedStreetScapeId: action.streetScapeTrackerId,
							formState: initialState.formState,
							commentsHistory: initialState.commentsHistory,
							siteLocalDropdown: initialState.siteLocalDropdown,
							siteClusterDropdown: initialState.siteClusterDropdown,
							siteNameDropdown: initialState.siteNameDropdown,
							activationStatusDropdown: initialState.activationStatusDropdown,
							d7StatusDropdown: initialState.d7StatusDropdown,
						};
					}
					case GET_STREETSCAPE_TRACKER_TABLE: {
						return {
							...state,
							streetScapeTrackerTable: action.streetScapeTrackerTable
						};
					}
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_STREETSCAPE_TRACKER: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.streetScapeTracker }
							}
						};
					}
					case GET_COMMENTS_HISTORY: {
						return {
							...state,
							commentsHistory: {
								...state.commentsHistory,
								[action.commentType]: action.commentsHistory
							}
						};
					}
					case GET_LOCAL_DROPDOWN: {
						return {
							...state,
							siteLocalDropdown: action.siteLocalDropdown
						};
					}
					case GET_CLUSTER_DROPDOWN: {
						return {
							...state,
							siteClusterDropdown: action.siteClusterDropdown
						};
					}
					case GET_SITENAME_DROPDOWN: {
						return {
							...state,
							siteNameDropdown: action.siteNameDropdown
						};
					}
					case GET_STREETSCAPE_TRACKER_TO_EDIT: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.streetScapeTracker }
							}
						};
					}
					case GET_ACTIVATION_STATUS_DROPDOWN: {
						return {
							...state,
							activationStatusDropdown: action.activationStatusDropdown
						};
					}
					case GET_D7_STATUS_DROPDOWN: {
						return {
							...state,
							d7StatusDropdown: action.d7StatusDropdown
						};
					}
					default: {
						return state;
					}
	}
};

export default streetScapeTrackerReducer;
